// dashboardActions.js
import {
    FETCH_DASHBOARD,
    LOADING_DASHBOARD,
    SET_FILTRO_DASHBOARD,
    FETCH_TOTALIZADORES_TARJETA,
    FETCH_RESUMEN_ESTADOS,
    FETCH_TOP_PRODUCTOS,
    FETCH_TOP_CATEGORIAS,
    FETCH_TOP_TIPO_PUBLICACIONES
} from './types';

import {
    getTotalizadores,
    fetchDashboardTotalizadoresApi,
    getEstadoResumen,
    getTopProducto,
    getTopCategorias,
    getTopTipoPublicaciones
} from '../api/axios'; //  importar el que ya tenés



export const setFiltroDashboard = (filtro) => dispatch => {
    dispatch({
        type: SET_FILTRO_DASHBOARD,
        payload: filtro
    });
};

//export const fetchDashboardCoreTotalizadores = (idSeller) => async (dispatch) => {
export const fetchDashboardCoreTotalizadores = (params) => async (dispatch) => {
    dispatch({
        type: LOADING_DASHBOARD,
        payload: true
    });

    try {
        // Normalizar params:
        // - si paso un id (number|string) -> { IdSeller: id }
        // - si paso null/undefined -> null (sin query)
        // - si ya es objeto -> lo uso tal cual
        const normalizedParams =
            params === null || params === undefined
                ? null
                : (typeof params === 'number' || typeof params === 'string')
                    ? { IdSeller: params }
                    : params;

        // Opcional: logging para depuración
        // console.debug('fetchDashboardCoreTotalizadores params:', normalizedParams);

        const resp = await getTotalizadores(normalizedParams);

        // Normalizo por si tu API viene envuelta o no y/o usa data de axios
        const root = resp?.data ?? resp;
        const tarjetas =
            root?.tarjetasDashboardDto ??
            root?.tarjetasDashboardDTO ??  // por si cambia el casing
            root?.tarjetaDashboardDtoHelperResponse ?? // fallback observado
            root;                          // si ya es el objeto

        dispatch({
            type: FETCH_TOTALIZADORES_TARJETA,
            payload: tarjetas, // <- esto queda guardado en el reducer
        });

        return tarjetas; // por si querés usar .then en el componente
    } catch (err) {
        // mejor log que rethrow para evitar overlay no controlado en dev
        console.error('fetchDashboardCoreTotalizadores error:', err);
        throw err;
    } finally {
        dispatch({ type: LOADING_DASHBOARD, payload: false });
    }
};


export const fetchResumenEstadosDeOrdenes = (params) => async (dispatch) => {
    dispatch({
        type: LOADING_DASHBOARD,
        payload: true,
    });

    try {
        // Normalizar params
        const normalizedParams =
            params === null || params === undefined
                ? null
                : (typeof params === 'number' || typeof params === 'string')
                    ? { IdSeller: params }
                    : params;

        const resp = await getEstadoResumen(normalizedParams);
        const root = resp?.data ?? resp;

        // ⬇️ Normaliza: admite {resumenEstadosOrden:{...}} o el objeto plano {...}
        const resumen = root?.resumenEstadosOrden ?? root;

        dispatch({
            type: FETCH_RESUMEN_ESTADOS,
            payload: resumen,
        });

        return resumen;
    } catch (err) {
        throw err;
    } finally {
        dispatch({
            type: LOADING_DASHBOARD,
            payload: false,
        });
    }
};


export const fetchTopProductosSeller = (params) => async (dispatch) => {

    // dispatch({ type: LOADING_DASHBOARD, payload: true });
    try {
        const normalizedParams =
            params === null || params === undefined
                ? null
                : (typeof params === 'number' || typeof params === 'string')
                    ? { IdSeller: params }
                    : params;

        const resp = await getTopProducto(normalizedParams);

        // Normalizo la respuesta sea response o response.data
        const root = resp?.data ?? resp;

        // Soporta varias formas: { topProductos: [...] }, { TopProductos: [...] }, o { data: { topProductos: [...] } }
        const topCandidate = root?.topProductos ?? root?.TopProductos ?? root;
        const payload =
            topCandidate?.data?.topProductos ??
            topCandidate?.topProductos ??
            topCandidate;

        dispatch({
            type: FETCH_TOP_PRODUCTOS,
            payload: payload,
        });

        return payload;
    } catch (err) {
        throw err; // o despachar action de error
    } finally {
        // dispatch({ type: LOADING_DASHBOARD, payload: false });
    }
};


export const fetchTopCategorias = (params) => async (dispatch) => {
    try {
        const normalizedParams =
            params === null || params === undefined
                ? null
                : (typeof params === 'number' || typeof params === 'string')
                    ? { IdSeller: params }
                    : params;

        const resp = await getTopCategorias(normalizedParams);
        // Soporta camelCase y PascalCase sin cambiar tu lógica
        const top = resp?.topProductos ?? resp?.TopProductos ?? resp;
        dispatch({
            type: FETCH_TOP_CATEGORIAS,
            payload: top,
        });

    } catch (err) {
        throw err; // o despachar action de error
    } finally {
        // dispatch({ type: LOADING_DASHBOARD, payload: false });
    }
};

export const fetchTopTipoPublicaciones = (params) => async (dispatch) => {
    try {
        const normalizedParams =
            params === null || params === undefined
                ? null
                : (typeof params === 'number' || typeof params === 'string')
                    ? { IdSeller: params }
                    : params;

        const resp = await getTopTipoPublicaciones(normalizedParams);
        const top = resp?.topProductos ?? resp?.TopProductos ?? resp;

        dispatch({
            type: FETCH_TOP_TIPO_PUBLICACIONES,
            payload: top,
        });

    } catch (err) {
        throw err;
    }
};